import React, { useEffect, useState } from "react";
import TableComponent from "./TableComponent";
import Preloader from "../shared/PreLoaders";

const WeeklyLoginReport = () => {
    const [data, setData] = useState([]);
    const [type, setType] = useState("week"); // week | month
    const [offset, setOffset] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [loginType, setLoginType] = useState("login");
    // "login" | "notlogin"

    const Api = process.env.REACT_APP_API;

    useEffect(() => {
        const fetchReport = async () => {
            try {
                setLoading(true);

                let url = "";

                if (type === "week") {
                    url =
                        loginType === "login"
                            ? `${Api}/api/activity-log/weekly-logins?weekOffset=${offset}`
                            : `${Api}/api/activity-log/weeklyNotLogins?weekOffset=${offset}`;
                } else {
                    const baseDate = new Date();
                    baseDate.setMonth(baseDate.getMonth() - offset);
                    const month = baseDate.toISOString().slice(0, 7);

                    url =
                        loginType === "login"
                            ? `${Api}/api/activity-log/monthly-logins?month=${month}`
                            : `${Api}/api/activity-log/monthlyNotLogins?month=${month}`;
                }

                const res = await fetch(url);
                if (!res.ok) throw new Error("Failed to load report");

                const result = await res.json();
                setData(result.data || result.users || []);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchReport();
    }, [Api, type, offset, loginType]);


    const columns =
        loginType === "login"
            ? [
                {
                    headerName: "SI.No",
                    valueGetter: (params) => params.node.rowIndex + 1,
                },
                { headerName: "User Name", field: "name" },
                { headerName: "Email", field: "email" },
                { headerName: "Login Count", field: "loginCount" },
                { headerName: "Other Activities", field: "otherActivityCount" },
                {
                    headerName: "Last Activity",
                    field: "lastActivity",
                    valueFormatter: (p) =>
                        p.value ? new Date(p.value).toLocaleString() : "-",
                },
            ]
            : [
                {
                    headerName: "SI.No",
                    valueGetter: (params) => params.node.rowIndex + 1,
                },
                { headerName: "User Name", field: "name" },
                { headerName: "Email", field: "email" },
                {
                    headerName: "Role",
                    valueGetter: (p) => p.data.role?.roleName || "-",
                },
                { headerName: "Circle(s)", valueGetter: p => p.data.circleNames?.join(", ") || "-" },
                { headerName: "Division(s)", valueGetter: p => p.data.divisionNames?.join(", ") || "-" }

            ];



    if (error) return <p style={{ color: "red" }}>{error}</p>;

    return (
        <div className="table-responsive">


            {/* ===== WEEK SELECT ===== */}
            <div className="mb-3 d-flex gap-3 align-items-center">

                <label><strong>Login Status:</strong></label>
                <select
                    className="form-select w-auto"
                    value={loginType}
                    onChange={(e) => {
                        setLoginType(e.target.value);
                        setOffset(0);
                    }}
                >
                    <option value="login">Logged In Users</option>
                    <option value="notlogin">Not Logged In Users</option>
                </select>
                <label><strong>Report Type:</strong></label>
                <select
                    className="form-select w-auto"
                    value={type}
                    onChange={(e) => {
                        setType(e.target.value);
                        setOffset(0);
                    }}
                >
                    <option value="week">Weekly</option>
                    <option value="month">Monthly</option>
                </select>

                <select
                    className="form-select w-auto"
                    value={offset}
                    onChange={(e) => setOffset(Number(e.target.value))}
                >
                    <option value={0}>
                        {type === "week" ? "Current Week" : "Current Month"}
                    </option>
                    <option value={1}>
                        {type === "week" ? "Previous Week" : "Previous Month"}
                    </option>
                    <option value={2}>
                        2 {type === "week" ? "Weeks" : "Months"} Ago
                    </option>
                    <option value={3}>
                        3 {type === "week" ? "Weeks" : "Months"} Ago
                    </option>
                </select>

            </div>


            {loading && <Preloader loading />}

            {!loading && (
                <>
                    <TableComponent data={data} columns={columns} />
                    {data.length === 0 && (
                        <p style={{ textAlign: "center" }}>No data available</p>
                    )}
                </>
            )}
        </div>
    );
};

export default WeeklyLoginReport;
